import { createContext } from "react";

export const billingFilterOptions = (
  parentCompanyList,
  subCompanyList,
  cityList,
  defaultValues,
  billingType,
  employeeList,
) => {
  const filters = [
    {
      id: 1,
      name: "parentCompanyName",
      label: "Company Name",
      placeholder: "Choose Company",
      options: parentCompanyList,
      defaultValues: defaultValues?.parentCompany || {},
    },
    {
      id: 2,
      name: "city",
      label: "City",
      placeholder: "Choose City",
      options: cityList,
      defaultValues: defaultValues?.cityValue || {},
    },
  ];

  if (billingType === "billToCreditCard") {
    filters.push({
      id: 3,
      name: "employee",
      label: "Employee",
      placeholder: "Choose Employee",
      options: employeeList || [],
      defaultValues: defaultValues?.employee || {},
    });
  }

  return filters;
};

export const biillingTabs = [
  {
    label: "Bill To Company",
    value: "billToCompany",
  },
  {
    label: "Bill To Self",
    value: "billToCreditCard",
  },
];

export const billingCompanyCardTabs = [
  {
    label: "All",
    value: "all",
  },
  {
    label: "Pending Approval",
    value: "pendingApproval",
  },
  {
    label: "Approve for charge",
    value: "approvalForCharge",
  },
  {
    label: "Dispute",
    value: "dispute",
  },
  {
    label: "Final Invoice",
    value: "charged",
  },
];

export const billingCreditCardTabs = [
  {
    label: "Eligible Invoices",
    value: "approvalForCharge",
  },
  {
    label: "Final Invoice",
    value: "charged",
  },
];
